


/**
 * Organiza os pais e filhos, mantendo os filhos depois do pai
 * @param {*} fields 
 * @returns 
 */
export function enforceParentChildOrder(fields) {
    const childIds = new Set();
    fields.forEach((f) => {
        (f.checkValueIn || []).forEach((c) => childIds.add(c.field));
    });

    const result = [];
    fields.forEach((f) => {
        if (childIds.has(f._id)) return;

        result.push(f);

        const children = (f.checkValueIn || [])
            .map((c) => fields.find((x) => x._id === c.field))
            .filter(Boolean);

        children.forEach((child) => result.push(child));
    });

    return result.map((f, i) => ({ ...f, index: i }));
}